const pad2 = (n) => String(n).padStart(2, '0');

/**
 * Formats date to "YYYY-MM-DD HH:MM" (24h).
 * Accepts Date | ISO string | unix ms | unix sec.
 */
export function formatDateTime(value) {
  if (value === null || value === undefined || value === '') return '—';

  let d;
  if (value instanceof Date) {
    d = value;
  } else if (typeof value === 'number') {
    // Heuristic: treat < 1e12 as seconds, otherwise ms
    d = new Date(value < 1e12 ? value * 1000 : value);
  } else {
    d = new Date(value);
  }

  if (Number.isNaN(d.getTime())) return '—';

  const yyyy = d.getFullYear();
  const mm = pad2(d.getMonth() + 1);
  const dd = pad2(d.getDate());
  const hh = pad2(d.getHours());
  const min = pad2(d.getMinutes());

  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
}


/**
 * Short relative time ("5 min ago", "3 h ago", "2 d ago"); older than a week
 * falls back to formatDateTime. `t` supplies the localized units.
 */
export function formatRelative(value, t) {
  const d = new Date(value);
  if (value == null || Number.isNaN(d.getTime())) return '—';
  const sec = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (sec < 60) return t('time.justNow');
  if (sec < 3600) return t('time.minAgo', { n: Math.floor(sec / 60) });
  if (sec < 86400) return t('time.hourAgo', { n: Math.floor(sec / 3600) });
  if (sec < 7 * 86400) return t('time.dayAgo', { n: Math.floor(sec / 86400) });
  return formatDateTime(d);
}

/** "DD.MM.YYYY" (local time). Accepts the same inputs as formatDateTime. */
export function formatDate(value) {
  const full = formatDateTime(value);
  if (full === '—') return full;
  const [y, m, d] = full.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
}
